import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { addDays } from "date-fns";
import { CalendarClock, MapPin } from "lucide-react";
import { api } from "@/lib/api";
import { dateKey, fmtRo, nowLocal, timeOf } from "@/lib/cal";

const dayLabel = (s) => {
  const today = dateKey(new Date());
  const key = s.slice(0, 10);
  if (key === today) return "Azi";
  if (key === dateKey(addDays(new Date(), 1))) return "Mâine";
  return fmtRo(new Date(`${key}T00:00`), "EEE d MMM");
};

export const MyAppointments = () => {
  const [me, setMe] = useState(null);
  const [appts, setAppts] = useState([]);

  useEffect(() => {
    api.get("/staff/me").then(async ({ data: staff }) => {
      if (!staff) return;
      setMe(staff);
      const today = new Date();
      const { data } = await api.get("/appointments", { params: { start: dateKey(today), end: dateKey(addDays(today, 7)), staff_id: staff.id } });
      const now = nowLocal();
      setAppts(data.filter((a) => a.status !== "anulat" && a.end > now));
    });
  }, []);

  if (!me) return null;
  return (
    <div className="mb-6 rounded-xl border bg-card p-5" data-testid="my-appointments-widget">
      <div className="mb-3 flex items-center justify-between">
        <h2 className="flex items-center gap-2 text-lg font-bold tracking-tight"><CalendarClock className="h-5 w-5 text-primary" /> Programările mele</h2>
        <Link to="/programari" className="text-sm font-semibold text-primary hover:underline" data-testid="my-appointments-calendar-link">Calendarul meu →</Link>
      </div>
      {appts.length === 0 ? (
        <p className="text-sm text-muted-foreground" data-testid="my-appointments-empty">Nicio programare în următoarele 7 zile.</p>
      ) : (
        <div className="grid grid-cols-1 gap-2 md:grid-cols-2 xl:grid-cols-3">
          {appts.slice(0, 6).map((a) => (
            <div key={a.id} className="flex gap-3 rounded-lg border-l-4 bg-background/50 p-3" style={{ borderLeftColor: me.color }} data-testid={`my-appt-${a.id}`}>
              <div className="w-16 shrink-0">
                <div className="text-xs font-semibold uppercase text-muted-foreground">{dayLabel(a.start)}</div>
                <div className="font-mono text-sm font-semibold">{timeOf(a.start)}</div>
              </div>
              <div className="min-w-0">
                <div className="truncate font-semibold">{a.service_name}</div>
                {a.client_name && <div className="truncate text-xs text-muted-foreground">{a.client_name}</div>}
                {a.address && <div className="flex items-center gap-1 truncate text-xs text-muted-foreground"><MapPin className="h-3 w-3 shrink-0" />{a.address}</div>}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
